import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import {useRoute} from "vue-router";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import EntidadesLayout from "@/layouts/EntidadesLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutProvider',
  setup(__props) {

const route = useRoute();

const layout = computed( () => {
  const layout = route?.meta?.layout;
  if (layout) {
    return DashboardLayout;
  } else {
    return EntidadesLayout;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})